import { render, staticRenderFns } from "./ChooseBranchesToPinDialog.vue?vue&type=template&id=452a42ac"
import script from "./ChooseBranchesToPinDialog.vue?vue&type=script&lang=js"
export * from "./ChooseBranchesToPinDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports